import type React from 'react'

interface InfluencersFilledIconProps {
  size?: number | string
  color?: string
  className?: string
}

const InfluencersFilledIcon: React.FC<InfluencersFilledIconProps> = ({ size = 24, color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={'Influencers Filled Icon'}
      role="img"
    >
      <g opacity="0.4">
        <path
          d="M9 2C6.38 2 4.25 4.13 4.25 6.75C4.25 9.32 6.26 11.4 8.88 11.49C8.96 11.48 9.04 11.48 9.1 11.49C9.12 11.49 9.13 11.49 9.15 11.49C9.16 11.49 9.16 11.49 9.17 11.49C11.73 11.4 13.74 9.32 13.75 6.75C13.75 4.13 11.62 2 9 2Z"
          fill={color}
        />
        <path
          d="M19.99 7.34C20.15 9.28 18.77 10.98 16.86 11.21C16.85 11.21 16.85 11.21 16.84 11.21H16.81C16.75 11.21 16.69 11.21 16.64 11.23C15.67 11.28 14.78 10.97 14.11 10.4C15.14 9.48 15.73 8.1 15.61 6.6C15.54 5.79 15.26 5.05 14.84 4.42C15.22 4.23 15.66 4.11 16.11 4.07C18.07 3.9 19.82 5.36 19.99 7.34Z"
          fill={color}
        />
      </g>
      <path
        d="M14.0809 14.1499C11.2909 12.2899 6.74094 12.2899 3.93094 14.1499C2.66094 14.9999 1.96094 16.1499 1.96094 17.3799C1.96094 18.6099 2.66094 19.7499 3.92094 20.5899C5.32094 21.5299 7.16094 21.9999 9.00094 21.9999C10.8409 21.9999 12.6809 21.5299 14.0809 20.5899C15.3409 19.7399 16.0409 18.5999 16.0409 17.3599C16.0309 16.1299 15.3409 14.9899 14.0809 14.1499Z"
        fill={color}
      />
      <path
        d="M21.9909 16.5899C21.9109 17.5599 21.2909 18.3999 20.2509 18.9699C19.2509 19.5199 17.9909 19.7799 16.7409 19.7499C17.4609 19.0999 17.8809 18.2899 17.9609 17.4299C18.0609 16.1899 17.4709 14.9999 16.2909 14.0499C15.6209 13.5199 14.8409 13.0999 13.9909 12.7899C16.2009 12.1499 18.9809 12.5799 20.6909 13.9599C21.6109 14.6999 22.0809 15.6299 21.9909 16.5899Z"
        fill={color}
      />
    </svg>
  )
}

export default InfluencersFilledIcon
